const columnsTemp = [
    {
        name: 'No',
        title: '序号',
        sortAble: false,
    },
    {
        name: 'CompanyName',
        title: '申报企业',
        sortAble: false,
    },
    {
        name: 'PlateName',
        title: '拟上市地',
        sortAble: false,
    },
    {
        name: 'SponsorName',
        title: '保荐机构',
        sortAble: false,
    },
    {
        name: 'AccountingFirm',
        title: '会计师事务所',
        sortAble: false,
    },
    {
        name: 'LawFirm',
        title: '律师事务所',
        sortAble: false,
    },
    {
        name: 'DeclareState',
        title: '备注',
        sortAble: false,
    },
];

export default columnsTemp;
